module.exports = __webpack_public_path__ + "img/3.af9953c5.png";